import React, { useEffect, useState } from "react";
import { Table, Button, Select, Input, Tag, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FaEye } from "react-icons/fa";
import { getStates } from "../features/statecity/statecitySlice";
import { getUsers } from "../features/cutomers/customerSlice";
import { getBrands } from "../features/brand/brandSlice";
import { getAssesmentList, resetState } from "../features/assesments/assesmentSlice";
import { ExportOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";

const { Search } = Input;

const columns = [
  {
    dataIndex: "key",
    title: "Sr No",
    width: 10,
  },
  {
    dataIndex: "state",
    title: "State",
    width: 30,
  },
  {
    dataIndex: "School",
    title: "School",
    width: 30,
  },
  {
    dataIndex: "classes",
    title: "Class",
    width: 30,
  },
  {
    dataIndex: "roll_no",
    title: "Role No.",
    width: 30,
  },
  {
    dataIndex: "student_name",
    title: "Student Name",
    width: 50,
  },
  {
    dataIndex: "job_role",
    title: "Job Role",
    width: 30,
  },
  {
    dataIndex: "assesement_by",
    title: "Assesment By",
    width: 40,
  },
  {
    dataIndex: "assesement_status",
    title: "Assesment Status",
    width: 40,
  },
];

const Assesmentreport = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [selectedTab, setSelectedTab] = useState("9");
  const [vcData, setvcData] = useState([]);
  const [vtData, setvtData] = useState([]);
  const [selectedVC, setselectedVC] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedVT, setSelectedVT] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredStatus, setFilteredStatus] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [totalStudents, setTotalStudents] = useState(0); // New state for total students

  const statelistState = useSelector((state) => state.statecity.statelist);
  const vclistState = useSelector((state) => state.customer.customers);
  const classlistState = useSelector((state) => state.brand.brands);

  useEffect(() => {
    dispatch(resetState());
    dispatch(getAssesmentList());
    dispatch(getStates());
    dispatch(getUsers());
    dispatch(getBrands());
  }, [dispatch]);

  const assesmentlist = useSelector((state) => state.assesmentlist.assesmentlists || []);
  console.log("Print Assesment List Data ----", assesmentlist);

  useEffect(() => {
    if (assesmentlist.length > 0 && !initialDataLoaded) {
      setTotalStudents(assesmentlist.length); // Set the total number of students
      handleViewSearch();
      setInitialDataLoaded(true);
    }
  }, [assesmentlist, initialDataLoaded]);

  const handleChangeTab = (key) => {
    setSelectedTab(key);
  };

  const handleVcChange = (value) => {
    const vtfilterData = vclistState.filter(
      (customer) => customer.vcuser_id === value
    );
    setvtData(vtfilterData);
    setselectedVC(value);
  };

  const handleStateChange = (value) => {
    const vcfilterData = vclistState.filter(
      (customer) => customer.state === value
    );
    setvcData(vcfilterData);
    setSelectedState(value);
  };

  const handleVTChange = (value) => {
    setSelectedVT(value);
    console.log("Print VT ID ---", selectedVT);
  };

  const handleClassChange = (value) => {
    setSelectedClass(value);
    console.log("Print Selected Class -----", selectedClass);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const handleViewSearch = () => {
    const filteredData = assesmentlist.filter((Assesment) => {
      const matchesState = selectedState
        ? Assesment.studentDetails.State === selectedState
        : true;
      const matchesVT = selectedVT
        ? Assesment.userDetails._id === selectedVT
        : true;
      const matchesClass = selectedClass
        ? Assesment.class === selectedClass
        : true;
      const matchesStatus = filteredStatus
        ? Assesment.assesment_status === filteredStatus
        : true;

      return matchesState && matchesVT && matchesClass && matchesStatus;
    });

    setFilteredData(filteredData);
  };

  const handleStatusClick = (status) => {
    setFilteredStatus(status);
    handleViewSearch();
  };

  const handleClear = () => {
    form.resetFields();
    setSelectedState("");
    setselectedVC("");
    setSelectedVT("");
    setSelectedClass("");
    setFilteredStatus("");
    setFilteredData(assesmentlist);
    setvcData([]);
    setvtData([]);
  };

  const summary = filteredData.reduce(
    (acc, curr) => {
      if (curr.assesment_status === "1") acc.pass += 1;
      else if (curr.assesment_status === "2") acc.fail += 1;
      else if (curr.assesment_status === "3") acc.absent += 1;
      return acc;
    },
    { pass: 0, fail: 0, absent: 0 }
  );

  const data1 = filteredData.map((Asseseslist, index) => {
    return {
      key: index + 1,
      state: Asseseslist.studentDetails.State,
      classes: Asseseslist.class,
      School: Asseseslist.studentDetails.School,
      roll_no: Asseseslist.studentDetails.Roll_Number,
      student_name: Asseseslist.studentDetails.Student_name || "N/A",
      job_role: Asseseslist.job_role || "N/A",
      assesement_by: Asseseslist.userDetails.name || "N/A",
      assesement_status:
        Asseseslist.assesment_status === "1"
          ? "Pass"
          : Asseseslist.assesment_status === "2"
          ? "Fail"
          : "Absent",
    };
  });

  const csvHeaders = [
    { label: "Sr. No", key: "key" },
    { label: "State", key: "state" },
    { label: "Class", key: "classes" },
    { label: "School", key: "School" },
    { label: "Roll Number", key: "roll_no" },
    { label: "Student Name", key: "student_name" },
    { label: "Job Role", key: "job_role" },
    { label: "Assesment By", key: "assesement_by" },
    { label: "Assesment Status", key: "assesement_status" },
  ];

  return (
    <div>
      <h3 className="mb-4 title">Assesment Reports</h3>
      <div
        style={{
          marginBottom: 16,
          backgroundColor: "#ffffff",
          border: "1px solid #eef2f6",
          padding: "20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "12px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
        }}
      >
        <div style={{ display: "flex", gap: "16px" }}>
          <Form form={form} layout="inline" onFinish={handleViewSearch}>
            <Form.Item
              name="state_name"
              rules={[
                {
                  required: true,
                  message: "Please Select State!",
                },
              ]}
            >
              <Select
                style={{ width: 160 }}
                placeholder="Select State"
                onChange={handleStateChange}
              >
                <Select.Option key="default" value="">
                  Select State
                </Select.Option>
                {statelistState.map((i, j) => (
                  <Select.Option key={j} value={i.code}>
                    {i.state_name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="state_vc">
              <Select
                style={{ width: 160 }}
                placeholder="Select VC"
                onChange={handleVcChange}
              >
                <Select.Option key="default" value="">
                  Select VC
                </Select.Option>
                {vcData
                  .filter((item) => item.role === "vc")
                  .map((item) => (
                    <Select.Option key={item._id} value={item._id}>
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item name="state_vt">
              <Select
                style={{ width: 160 }}
                placeholder="Select VT"
                onChange={handleVTChange}
              >
                <Select.Option key="default" value="">
                  Select VT
                </Select.Option>
                {vtData
                  .filter((item) => item.role === "vt")
                  .map((item) => (
                    <Select.Option key={item._id} value={item._id}>
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item name="state_class">
              <Select
                style={{ width: 160 }}
                placeholder="Select Class"
                onChange={handleClassChange}
              >
                <Select.Option key="default" value="">
                  Select Class
                </Select.Option>
                {classlistState.map((cls, index) => (
                  <Select.Option key={index} value={cls.title}>
                    {cls.title}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item>
              <Button
                style={{ marginRight: 20, backgroundColor: "#a7b54d" }}
                type="primary"
                htmlType="submit"
              >
                <FaEye /> &nbsp; Search
              </Button>
            </Form.Item>

            <Form.Item>
              <Button type="default" onClick={handleClear}>
                Clear
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>

      <div
        style={{
          color: "white",
          marginBottom: 1,
          display: "flex",
          justifyContent: "flex-end",
          flexGrow: 1,
        }}
      >
        <div style={{ display: "flex", gap: "20px" }}>
          <div 
          onClick={() => handleStatusClick("1")} 
          style={{ cursor: "pointer" }}
          >
            <Tag color="green">Total Pass: {summary.pass}</Tag>
          </div>
          <div 
          onClick={() => handleStatusClick("2")} 
          style={{ cursor: "pointer" }}
          >
            <Tag color="red">Total Fail: {summary.fail}</Tag>
          </div>
          <div 
          onClick={() => handleStatusClick("3")} 
          style={{ cursor: "pointer" }}
          >
            <Tag color="yellow">Total Absent: {summary.absent}</Tag>
          </div>
          <div
           onClick={handleClear}
           style={{ cursor: "pointer" }}
          >
            <Tag color="blue">Total Students: {totalStudents}</Tag> {/* Fixed total students */}
          </div>
        </div>
      </div>

      <CSVLink
        data={data1}
        headers={csvHeaders}
        filename={`Assesment-Report${new Date().toISOString()}.csv`}
      >
        <Button type="primary" className="exportcsv" style={{}}>
          <ExportOutlined /> Export to CSV
        </Button>
      </CSVLink>

      <Table
        style={{ marginBottom: 16, padding: "20px" }}
        className="custom-table"
        columns={columns}
        dataSource={data1}
        // pagination={{ pageSize: 20 }}
        size="small"
      />
    </div>
  );
};

export default Assesmentreport;
